import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SuspendActionClass;
function SuspendAction() {
  if (SuspendActionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SuspendAction', VOID, VOID, VOID, [1]);
    SuspendActionClass = $;
  }
  return SuspendActionClass;
}
//region block: exports
export {
  SuspendAction as SuspendAction33643gogpgl0e,
};
//endregion

//# sourceMappingURL=SuspendAction.mjs.map
